import { AxiosApi } from "../AxiosApi"

export class NameCols {
    constructor(){
    }
    static async getLabel() {
        let data_send = "?n=1&command=GET_PRODUCT_CONF_COLS&cislo_nomenklatury="+ id_nomen;
        let data = await AxiosApi(data_send);
        if (data.root.smako_conf_cols) {
            let conf_cols = data.root.smako_conf_cols.column;
            for (let dataLabel in conf_cols) {
                $(".label-" + conf_cols[dataLabel].column).text( conf_cols[dataLabel].label );
                window.labelName[conf_cols[dataLabel].column] = conf_cols[dataLabel].label;
                window.helps[conf_cols[dataLabel].column] = conf_cols[dataLabel].help;

                if (conf_cols[dataLabel].must == 1) {
                    window.validator.push(conf_cols[dataLabel].column);
                }
            }
        }

    }
}